module.exports = __webpack_public_path__ + "assets/img/login_icon2.47a4f95e.png";